<!-- eslint-disable max-lines -->
<template>
    <div>
        <el-dialog :width="config.dialogWidth ? config.dialogWidth : '800px'" :visible.sync="dialogVisible"
            :append-to-body="true" @close="dialogClose" :close-on-click-modal="false">
            <template v-slot:title>
                <div class="column-config_title">
                    {{ dialogTitle }}
                </div>
            </template>
            <div class="component-container">
                <div class="top-search-group mui-advance">
                    <el-row :gutter="20">
                        <el-col :span="multiple ? 16 : 24">
                            <el-form :inline="true" :model="searchObj">
                                <el-form-item v-if="config.specialType === 'cascader'">
                                    <el-cascader v-model="searchObj.keyword" :options="config.specialCascader"
                                        filterable clearable placeholder="请选择" :props="config.specialProps"
                                        @visible-change="visibleChange" />
                                </el-form-item>
                                <el-form class="form-filed" v-else-if="config.searchType == 'input'" size="mini" :inline="true"
                                    :model="searchObj">
                                    <el-form-item v-for="item in config.advanceConfig" :key="item.prop">
                                        <otpAdvance
                                            class="form-item-width"
                                            v-if="item.type === 'advance'"
                                            @getAdvanceValue="getAdvanceValue($event, item)"
                                            :mValue="searchObj[item.prop]"
                                            :params="item"
                                            clearable
                                            :disabled="false">
                                        </otpAdvance>
                                        <otpAdvanceMulti
                                            class="form-item-width"
                                            v-else-if="item.type === 'advanceMulti'"
                                            :ref="item.value"
                                            :params="item"
                                            @getAdvanceValue="(data) => { getMultiInfo(data, item); }"
                                            :mValue="searchObj[item.prop]"
                                            :formData="searchObj">
                                        </otpAdvanceMulti>
                                        <lots-select
                                            class="form-select-width"
                                            v-else-if="item.type === 'select'"
                                            :optionsKey="item.optionsKey ||'' "
                                            :placeholder="item.placeholder || `请选择${ item.value }`"
                                            v-model="searchObj[item.prop]"
                                            :multiple="item.multiple"
                                            clearable
                                             />
                                        <el-input v-model.trim="searchObj[item.prop]" v-else :placeholder="item.value"
                                            @keyup.enter="search"></el-input>
                                    </el-form-item>
                                </el-form>
                                <div class="mui-search-left" v-else>
                                    <el-form-item>
                                        <el-select v-model="searchObj.key" placeholder="请选择">
                                            <el-option v-for="option in selectOptions" :key="option.prop"
                                                :label="option.value" :value="option.prop" @change="changeHandle"></el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item>
                                        <el-input v-model.trim="searchObj.keyword" placeholder="请输入"
                                            @keyup.enter="search" @change="inputChange"></el-input>
                                    </el-form-item>
                                </div>

                                <el-form-item>
                                    <el-button type="primary" @click="search">查询</el-button>
                                    <el-button @click="reset">重置</el-button>
                                </el-form-item>
                                <el-form-item v-if="config.isAllSelect">
                                    <el-checkbox v-model="selectAll" class="selectAll">全选</el-checkbox>
                                </el-form-item>
                            </el-form>
                        </el-col>
                        <el-col :span="8" class="mui-clear-right" v-if="multiple">
                            <el-button v-if="config.MultipleConfig && config.MultipleConfig.hasClearBtn" type="primary"
                                @click="cleanRightTable">
                                清空列表
                            </el-button>
                        </el-col>
                    </el-row>
                </div>
                <el-row :gutter="20">
                    <el-col :span="multiple ? 16 : 24">
                        <el-table ref="multipleTable" :data="tableData" highlight-current-row v-loading="loading"
                            reserve-selection height="300" :border="config.border ? config.border : false"
                            @current-change="currentRowChange" @row-dblclick="rowDbClick" @row-click="selectionRow"
                            @select="handleSelect" @select-all="handleSelectAll">
                            <el-table-column v-if="config.selection" type="selection" width="40"
                                fixed="left"></el-table-column>
                            <el-table-column type="index" v-if="config.orderNumber" :label="config.orderNumberTitle"
                                width="50"></el-table-column>
                            <el-table-column v-for="(column, index) in config.tableConfig" :key="column.prop + index"
                                :prop="column.prop" :label="column.value" :width="column.width"
                                :show-overflow-tooltip="true">
                                <template v-slot="{ row, $index}">
                                    <template v-if="column.type === 'select'">
                                        {{ dictFormat(row[column.prop], column.optionsKey, column.options) }}
                                    </template>
                                    <template v-else-if="column.type ==='slot'">
                                        <slot name="col-append" v-bind="{ col:column, row: row, rIndex: $index }"></slot>
                                    </template>
                                    <template v-else>{{ row[column.prop] }}</template>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-col>
                    <el-col :span="8" v-if="multiple">
                        <el-table :data="advanceList" class="table-box" height="300" border v-loading="MultipleLoading"
                            highlight-current-row>
                            <template v-if="config.MultipleConfig">
                                <el-table-column type="index" v-if="config.MultipleConfig.orderNumber"
                                    :label="config.MultipleConfig.orderNumberTitle"
                                    :width="config.MultipleConfig.orderNumberWidth || 50"></el-table-column>
                                <el-table-column v-for="(column, index) in config.MultipleConfig.tableConfig"
                                    :key="column.prop + index" :prop="column.prop" :label="column.value"
                                    :width="column.width" :show-overflow-tooltip="true"></el-table-column>
                            </template>

                            <el-table-column v-else :prop="config.multipleTableColumn.prop"
                                :label="config.multipleTableColumn.value"></el-table-column>

                            <el-table-column fixed="right" label="操作" width="60">
                                <template v-slot="scope">
                                    <el-button class="deleteBtn" @click="deleteDate(scope.row, scope.$index)"
                                        size="small" type="text">
                                        删除
                                    </el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-col>
                </el-row>
                <div class="config-footer">
                    <el-row>
                        <el-col v-if="mode !== 'EbPlace' && !config.noPagination" :span="3" style="line-height: 30px">
                            共&nbsp;&nbsp;{{ pageTotal }}&nbsp;&nbsp;项
                        </el-col>
                        <el-col v-if="mode !== 'EbPlace' && !config.noPagination" :span="16">
                            <el-pagination size="mini" v-if="!config.noPagination" class="table-pagination"
                                layout="prev, pager, next" :current-page="page.pageNo" :page-size="page.pageSize"
                                :total="pageTotal" @current-change="currentChange"></el-pagination>
                        </el-col>
                        <el-col :offset="mode === 'EbPlace' || config.noPagination ? 19 : 0" :span="5"
                            style="text-align: right">
                            <el-button type="text" @click="dialogVisible = false">取消</el-button>
                            <el-button type="primary" @click="confirm" :disabled="disabledCancel">确定</el-button>
                        </el-col>
                    </el-row>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import _ from 'lodash';
import { mapGetters } from 'vuex';
import request from '@/utils/http';
import { dictWithUrl } from '@/components/lots/api';
import utils from '@/components/utils/common.js';
import otpAdvance from '@/components/lots/otpAdvance/Index.vue';
import otpAdvanceMulti from '@/components/lots/otpAdvanceMulti/index.vue';
import lotsSelect from '@/components/lots/lotsSelect/Index';
const { MAGIC_NUMBER } = utils;
// import { filterSpecChar } from '../utils';
const DEBUOUNCE_TIME = 80; // 全选点击后,全选复选时间
export default {
    props: {
        disabledDbClick: {
            type: Boolean,
            default: false
        },
        rejectClose: {
            type: Boolean,
            default: false
        }
    },
    components: {
        lotsSelect,
        otpAdvance,
        otpAdvanceMulti
    },
    computed: {
        ...mapGetters(['currentTenant']),
        selectOptions () {
            return this.config.advanceConfig || this.config.tableConfig;
        },
        dialogTitle () {
            return this.config.advanceLabel || this.config.name || this.config.label;
        }
    },
    data () {
        return {
            disabledCancel: false,
            dialogVisible: false,
            requestMethod: 'get',
            loading: false,
            page: {
                pageSize: 20,
                pageNo: 1
            },
            pageTotal: 0,
            searchObj: {},
            tableData: [],
            config: {},
            multiple: false,
            advanceList: [],
            oldAdvanceList: [],
            mode: '',
            optionsData: [],
            selectAll: false,
            selectable: row => {
                return row.show;
            },
            AllList: [],
            selectFlag: false,
            MultipleLoading: false
        };
    },
    watch: {
        dialogVisible (val) {
            if (!val) {
                this.disabledCancel = false;
            }
        },
        async selectAll (val) {
            if (val) {
                this.selectFlag = true;
                await this.fetchSelectAllData(this.config);
                this.advanceList = this.AllList;
                this.oldAdvanceList = [];
                await this.$refs.multipleTable.toggleAllSelection();
                const timer = setTimeout(() => {
                    this.selectFlag = false; // 阻止数据回填除非select/selectAll事件
                    clearTimeout(timer);
                }, DEBUOUNCE_TIME);
            } else {
                this.advanceList = [];
                this.oldAdvanceList = [];
                this.$refs.multipleTable.clearSelection();
            }
        }
    },

    methods: {
        /* eslint-disable complexity */
        // eslint-disable-next-line max-lines-per-function
        async fetchData () {
            this.loading = true;
            let params = {};
            let searchContent = {};
            // 对关键字的[]{}符号进行转义
            const keyword
                = this.requestMethod === 'get'
                    ? this.searchObj.keyword
                        .replace(/{/g, '%7b')
                        .replace(/}/g, '%7d')
                        .replace(/\[/g, '%5b')
                        .replace(/\]/g, '%5d')
                    : this.searchObj.keyword;
            if (this.searchObj.key === 'ALL') {
                params = { ...this.advanceCascade, ...this.page };
                for (let i = 1; i < this.selectOptions.length; i++) {
                    params[this.selectOptions[i].prop] = keyword;
                }
            } else if (this.paramType) {
                searchContent = this.getSearchObj(keyword);
                params = {
                    ...this.page,
                    ...(this.config.otherParams || {}),
                    param: { ...this.advanceCascade, ...searchContent }
                };
            } else {
                searchContent = this.getSearchObj(keyword);
                params = { ...this.advanceCascade, ...this.page, ...searchContent };
            }
            // 添加请求前钩子，用于非标准化基础数据接口对请求参数做数据转换
            const beforeReq = _.get(this.config, 'beforeRequest');
            if (beforeReq && _.isFunction(beforeReq)) {
                params = await beforeReq(params);
            }
            const reqConfig = {
                method: this.requestMethod,
                url: `${this.prefix}${this.config.advanceUrl}`
            };
            if (this.requestMethod === 'get') {
                reqConfig.params = params;
            } else {
                reqConfig.data = params;
            }
            if (this.hasTenant) {
                reqConfig.headers = { ...reqConfig.headers, tenantCode: this.currentTenant.tenantCode };
            }

            let res = await request(reqConfig);
            const afterRes = _.get(this.config, 'afterResponse');
            if (afterRes && _.isFunction(afterRes)) {
                res = afterRes(res);
            }
            if (res && res.code === '0') {
                if (res.data.totalPage !== 0 && this.page.pageNo > res.data.totalPage) {
                    this.page.pageNo = res.data.totalPage;
                    this.fetchData();
                } else {
                    this.tableData
                        = res.data.list?.map(item => {
                            item = this.disabledItemFn(item);
                            return item;
                        }) || [];
                    this.pageTotal = res.data.totalCount;
                    this.$nextTick(() => {
                        this.tableData.forEach(item => {
                            const Index = this.advanceList.findIndex(ele => String(ele?.id) === String(item?.id));
                            if (Index > -1) {
                                this.advanceList[Index] = _.cloneDeep(item);
                                Index > -1 && this.$refs.multipleTable.toggleRowSelection(item, true);
                            }
                        });
                        this.$refs.multipleTable.doLayout();
                    });
                }
                if (this.mode === 'EbPlace') {
                    // 处理地区选择时的格式情况
                    this.tableData = res.data;
                }
            } else {
                this.tableData = [];
            }
            this.loading = false;
        },
        disabledItemFn (item) {
            // if (item.saleStageId !== '中标确认' && item.saleStageId !== '合同签订') {
            //     item.disabledBid = true;
            // } else {
            const { bidDate, contractSearchDate } = item;
            const bidDateTime = bidDate ? new Date(bidDate).getTime() : null;
            const SearchDateTime = contractSearchDate ? new Date(contractSearchDate).getTime() : null;
            const nowTime = new Date().getTime();
            if (!bidDateTime && !SearchDateTime) {
                item.disabled30 = true;
            }
            if (bidDateTime) {
                const flag1 = Math.abs(nowTime - bidDateTime) > (60 * 60 * 24 * MAGIC_NUMBER.NINETY * 1000); // 大于当前3个月（90天）时间范围
                if (!SearchDateTime) {
                    item.disabled30 = flag1;
                } else {
                    const flag2 = Math.abs(nowTime - SearchDateTime) > (60 * 60 * 24 * MAGIC_NUMBER.NINETY * 1000); // 大于当前3个月（90天）时间范围
                    item.disabled30 = flag1 && flag2;
                }
            }
            // }
            return item;
        },
        // 获取搜索参数
        getSearchObj (keyword) {
            if (this.config.specialType === 'cascader' && keyword) {
                //                 params = { ...this.advanceCascade, ...this.page, [this.searchObj.key]: keyword };
                return { [this.searchObj.key]: keyword?.join('/') };
            } else if (this.config.searchType === 'input') {
                return { ...this.searchObj };
            } else {
                return { [this.searchObj.key]: keyword };
            }
        },
        /* eslint-disable complexity */
        // 已选择的数据回填
        async fetchMultipleData (config) {
            if (config.NoInsertFirstConfig) return;
            this.MultipleLoading = true;
            const params = { ...config.advanceCascade };
            // 对关键字的[]{}符号进行转义

            const reqConfig = {
                method: config.method,
                url: `${config.prefix}${config.advanceUrl}`
            };
            if (config.method === 'get') {
                reqConfig.params = params;
            } else {
                reqConfig.data = params;
            }
            if (config.hasTenant) {
                reqConfig.headers = { ...reqConfig.headers, tenantCode: this.currentTenant.tenantCode };
            }
            let res = await request(reqConfig);
            const afterRes = _.get(config, 'afterResponse');
            if (afterRes && _.isFunction(afterRes)) {
                res = afterRes(res);
            }
            if (res && res.code === '0') {
                const _selected = _.cloneDeep(this.advanceList);
                this.advanceList = (res.data && res.data.list) || _selected || [];

                this.oldAdvanceList = JSON.parse(JSON.stringify(this.advanceList));
            } else {
                this.advanceList = [];
            }
            this.MultipleLoading = false;
        },
        // 全选数据
        async fetchSelectAllData (config) {
            // this.MultipleLoading = true;
            let params = {};
            // 对关键字的[]{}符号进行转义
            const keyword
                = this.requestMethod === 'get'
                    ? this.searchObj.keyword
                        .replace(/{/g, '%7b')
                        .replace(/}/g, '%7d')
                        .replace(/\[/g, '%5b')
                        .replace(/\]/g, '%5d')
                    : this.searchObj.keyword;
            if (this.searchObj.key === 'ALL') {
                params = { ...this.advanceCascade, ...this.page };
                for (let i = 1; i < this.selectOptions.length; i++) {
                    params[this.selectOptions[i].prop] = keyword;
                }
            } else if (this.paramType) {
                params = {
                    ...this.page,
                    ...(this.config.otherParams || {}),
                    param: { ...this.advanceCascade, [this.searchObj.key]: keyword }
                };
            } else {
                params = { ...this.advanceCascade, ...this.page, [this.searchObj.key]: keyword };
            }
            // const params = { ...config.allSelectConfig.advanceCascade, ...this.page };
            // 对关键字的[]{}符号进行转义

            const reqConfig = {
                method: config.allSelectConfig.method,
                url: `${config.allSelectConfig.prefix}${config.allSelectConfig.advanceUrl}`
            };
            if (config.method === 'get') {
                reqConfig.params = params;
            } else {
                reqConfig.data = params;
            }
            if (config.hasTenant) {
                reqConfig.headers = { ...reqConfig.headers, tenantCode: this.currentTenant.tenantCode };
            }
            const res = await request(reqConfig);
            if (res && res.code === '0') {
                this.AllList = (res.data && res.data.list) || [];
            } else {
                this.AllList = [];
            }

            // this.MultipleLoading = false;
        },
        // eslint-disable-next-line complexity
        async show (status = true, config, advanceCascade = {}, mode = '', cache = [], keywords) {
            this.requestMethod = config.method || 'get';
            this.prefix = config.prefix || '/api-mdm/';
            this.hasTenant = config.hasTenant || false;
            this.dialogVisible = status;
            this.paramType = config.paramType || false;
            this.multiple = config.multiple ? config.multiple : false;

            if (status === false) return;
            if (!config) {
                this.$message.error('弹窗配置对象为空！');
                return;
            }
            if (this.multiple) {
                this.advanceList = [...cache];
                this.currentRow = cache;
            }

            this.mode = mode;
            this.config = config;
            // this.searchObj.key = config.searchObj ? config.searchObj.key : '';
            // this.searchObj.keyword = config.searchObj ? config.searchObj.keyword : '';
            this.advanceCascade = advanceCascade;
            // config.searchType 控制查询条件以 下拉框选择形式 还是 输入框全部展示，不传值默认为下拉框选择形式\
            if (config.searchType === 'input') {
                config.advanceConfig.forEach(item => {
                    this.$set(this.searchObj, item.prop, item.defaultValue || '');
                    // this.searchObj[item.prop] = item.defaultValue || '';
                    if (config.searchObj) {
                        this.$set(this.searchObj, config.searchObj.key, config.searchObj.keyword);
                    }
                });
            } else {
                this.$set(this.searchObj, 'key', this.selectOptions[0].prop);
                this.$set(this.searchObj, 'keyword', '');
            }
            await this.getDictData(config);
            config.MultipleConfig && (await this.fetchMultipleData(config.MultipleConfig));
            if (config.firstNoFetch) { // 打开第一次不请求
                this.tableData = [];
                this.page = {
                    pageSize: 20,
                    pageNo: 1
                };
                config.firstNoFetch = false;
                return;
            };
            await this.fetchData();
        },
        dictFormat (val, optionsKey, options) {
            if (optionsKey) {
                const keyMaps = _.get(this.optionsData, optionsKey);
                const optionsKeyValue = _.get(keyMaps, val, val);
                return optionsKeyValue;
            } else if (options) {
            // if (options) {
                return _.get(options, val, val);
            } else {
                return val;
            }
        },
        // 页码变化
        async currentChange (val) {
            this.page.pageNo = val;
            await this.fetchData();
            if (this.selectAll) {
                this.$refs.multipleTable.toggleAllSelection();
            }
            this.oldAdvanceList = JSON.parse(JSON.stringify(this.advanceList));
        },
        // 搜索
        search () {
            this.page.pageNo = 1;
            this.fetchData();
            this.selectAll = false;
            // this.oldAdvanceList = [];
        },
        // 重置
        reset () {
            if (this.config.searchType === 'input') {
                this.config.advanceConfig.forEach(item => {
                    this.searchObj[item.prop] = '';
                });
            } else {
                this.searchObj.keyword = '';
            }
            this.advanceList = [];
            this.fetchData();
            this.selectAll = false;
            this.oldAdvanceList = [];
        },
        // 表格
        currentRowChange (row) {
            if (row) {
                this.currentRow = row;
            }
        },
        // 表格双击
        rowDbClick (row) {
            if (this.disabledDbClick || this.config.disabledDbClick) return false;
            this._emitResult(row);
            this.$emit('row-db-click', row);
        },
        confirm () {
            if (!this.currentRow) {
                this.$message.warning('没选中数据');
                return;
            }

            this._emitResult(_.cloneDeep(this.currentRow));
        },
        // 返回选中值
        _emitResult(_row) {
            const row = _.cloneDeep(_row);
            const data = {};
            if (!this.config.cbParams) {
                this.$message.error('弹窗没定义cbParams配置!');
                return;
            }
            if (this.multiple) {
                const searchData = {};
                const cbParamList = [...this.config.tableConfig, ...(this.config.otherMultiple || [])];
                cbParamList.forEach(item => {
                    searchData[item.prop] = [];
                    this.advanceList.map(aitem => {
                        searchData[item.prop].push(aitem[item.prop]);
                    });
                    row[item.prop] = searchData[item.prop].join(this.config.splitType || ',');
                });
            }
            for (const item of this.config.cbParams) {
                let { 0: sourceProp, 1: destProp } = item.split('#');
                destProp = destProp || sourceProp;
                data[destProp] = row[sourceProp];
            }
            if (this.config.confirmCb) {
                const confirmCb = this.config.confirmCb;
                if (_.isFunction(confirmCb) && !confirmCb(data, this.config)) {
                    return false;
                }
            }
            this.$emit('confirm', data, this.config);
            if (this.config.noCloseDialog) return; // 弹窗回调
            if (this.rejectClose) {
                this.disabledCancel = true;
                return false;
            }
            this.dialogVisible = false;
        },
        changeVisible(val) {
            this.dialogVisible = val;
        },
        inputChange (val) { },
        dialogClose () {
            // 重置属性
            this.page = {
                pageSize: 20,
                pageNo: 1
            };
            this.pageTotal = 0;
            this.searchObj = {};
        },
        deleteDate(row, index) {
            this.$refs.multipleTable.toggleRowSelection(this.advanceList[index], false);
            this.advanceList.splice(index, 1);
            if (this.oldAdvanceList.findIndex(item => item.id === row.id) > -1) {
                this.oldAdvanceList = this.oldAdvanceList.filter(item => item.id !== row.id);
            }
        },
        selectionRow (currentRow) {
            // if (currentRow.disabledBid) {
            //     this.$message.warning('商机未中标，不允许关联');
            //     this.$refs.multipleTable.toggleRowSelection(currentRow, false);
            //     return;
            // } else if (currentRow.disabled30) {
            //     this.$message.warning('商机中标日期超出3个月，请与销售管理沟通后进行关联！');
            //     this.$refs.multipleTable.toggleRowSelection(currentRow, false);
            //     return;
            // } else {
            //     // this.$refs.multipleTable.toggleRowSelection(currentRow); // 不传true, 用于切换选中状态
            // }
            if (this.multiple) {
                let num = 0;
                // _key 判断数据是否重复,有些数据唯一值不一样
                const _key = this.config.multipleOnlyFiled
                    ? this.config.multipleOnlyFiled
                    : this.config.tableConfig[0].prop;
                this.advanceList.map(item => {
                    if (item[_key] === currentRow[_key]) {
                        num += 1;
                    }
                });
                if (num === 0) {
                    this.advanceList.push(currentRow);
                    this.$refs.multipleTable.toggleRowSelection(currentRow, true);
                }
            } else {
                this.advanceList = currentRow;
            }

            this.$emit('row-click', currentRow);
        },
        // 表格单击复选框
        handleSelect (selection, row) {
            if (this.selectFlag) return;
            this.selectAll = false;
            if (this.advanceList.length === 0) {
                this.advanceList = selection;
                return;
            }
            if (selection.length === 0) {
                // 删除最后一个
                this.advanceList = this.advanceList.filter(item => item.id !== row.id);
            } else {
                const currentSelection = []; // 当前选择的数据
                selection.forEach(item => {
                    if (item.id !== row.id) {
                        // 取消的情况,需要删除
                        this.advanceList = this.advanceList.filter(ele => ele.id !== row.id);
                    }
                    if (!this.advanceList.some(ele => ele.id === item.id)) {
                        currentSelection.push(item);
                    }
                });
                this.advanceList = [...this.advanceList, ...currentSelection];
            }
        },
        // 表格全选动作
        handleSelectAll (selection) {
            if (this.selectFlag) return;
            this.selectAll = false;
            if (this.advanceList.length === 0) {
                this.advanceList = selection;
                return;
            }
            if (selection.length === 0) {
                this.tableData.forEach(ele => {
                    this.advanceList = this.advanceList.filter(item => item.id !== ele.id);
                });
            } else {
                const currentSelection = []; // 当前选择的数据
                selection.forEach(item => {
                    if (!this.advanceList.some(ele => ele.id === item.id)) {
                        // 过滤右边已有的数据
                        currentSelection.push(item);
                    }
                });
                // 合并已有数据以及当前选择的数据
                this.advanceList = [...this.advanceList, ...currentSelection];
            }
        },
        // 部分浏览器多次下拉出现页面卡死问题处理
        visibleChange () {
            this.$nextTick(() => {
                // 添加这段代码
                const $el = document.querySelectorAll('.el-cascader-panel .el-cascader-node[aria-owns]');
                Array.from($el).forEach(item => item.removeAttribute('aria-owns'));
            });
        },
        // 清空列表
        cleanRightTable () {
            this.advanceList = [];
        },
        getAdvanceValue (val, config) {
            for (const item of config.cbParams) {
                let { 0: sourceProp, 1: destProp } = item.split('#');
                destProp = destProp || sourceProp;
                this.$set(this.searchObj, destProp, val[destProp]);
            }
        },
        /**
         * 多选弹窗回调获取信息
         */
        getMultiInfo(data, item) {
            const params = {};
            if (data && Array.isArray(data)) {
                if (data.length) {
                    const keyArr = Object.keys(data[0]);
                    keyArr.forEach(key => {
                        if (!params[key + 's']) { params[key + 's'] = []; }
                        data.forEach(subItem => {
                            params[key + 's'].push(subItem[key]);
                        });
                        params[key + 's'] = params[key + 's'].join();
                    });
                } else {
                    item.cbParams.forEach(keySub => {
                        const arr = keySub.split('#');
                        params[arr[arr.length - 1] + 's'] = null;
                    });
                }
            }
            Object.assign(this.searchObj, params);
        },
        async getDictData(config) {
            const dictCodes = [];
            config.tableConfig.forEach(item => {
                if (item.optionsKey) {
                    dictCodes.push(item.optionsKey);
                }
            });
            if (dictCodes.length) {
                await dictWithUrl({ dictCodes: String(dictCodes) }).then(res => {
                    if (+res.code === 0) {
                        this.optionsData = res.data;
                    }
                });
            }
        },
        changeHandle(e) {
            this.$forceUpdate(); // 强制刷新
        }
    }
};
</script>

<style lang="less">
.column-config_title {
    small {
        margin-left: 25px;
    }
}

.component-container {
    .config-footer {
        margin-top: 18px;
    }

    .table-pagination {
        float: left;
        padding: 0;

        .btn-prev,
        .btn-next,
        .el-pager li {
            // background-color: #ffffff !important;
            border: 1px solid #cccccc;
            border-radius: 4px !important;
        }

        .el-pager li.active+li {
            border-left: 1px solid #cccccc;
        }

        .el-pager li:not(.disabled).active {
            // background-color: #00bcbf !important;
            // border: 1px solid #00bcbf;
        }
    }
    .mui-advance .form-item-width{
        width: 174px;
    }
    .mui-advance .form-select-width{
        width: 150px;
    }
}

.mui-search-left {
    display: inline-block;
}

.mui-clear-right {
    display: flex !important;
    justify-content: flex-end;
    align-items: center;
}
.form-filed{
    display: inline-block;
}
</style>
